export interface RashiSadeSatiInfo {
  id: string;
  nameEn: string;
  nameHi: string;
  number: number;
  currentStatus: "rising" | "peak" | "setting" | "none";
  currentPhaseLabel: string;
  approximatePeriod: string;
  nextSadeSati: string;
}

export const RASHI_DATA: RashiSadeSatiInfo[] = [
  {
    id: "mesh",
    nameEn: "Aries",
    nameHi: "मेष",
    number: 1,
    currentStatus: "none",
    currentPhaseLabel: "Not Active",
    approximatePeriod: "~2027 - 2034",
    nextSadeSati: "Begins when Saturn enters Pisces (12th from Mesh)",
  },
  {
    id: "vrishabh",
    nameEn: "Taurus",
    nameHi: "वृषभ",
    number: 2,
    currentStatus: "none",
    currentPhaseLabel: "Not Active",
    approximatePeriod: "~2030 - 2037",
    nextSadeSati: "Begins when Saturn enters Aries",
  },
  {
    id: "mithun",
    nameEn: "Gemini",
    nameHi: "मिथुन",
    number: 3,
    currentStatus: "none",
    currentPhaseLabel: "Not Active",
    approximatePeriod: "~2032 - 2040",
    nextSadeSati: "Begins when Saturn enters Taurus",
  },
  {
    id: "kark",
    nameEn: "Cancer",
    nameHi: "कर्क",
    number: 4,
    currentStatus: "none",
    currentPhaseLabel: "Not Active",
    approximatePeriod: "~2035 - 2042",
    nextSadeSati: "Begins when Saturn enters Gemini",
  },
  {
    id: "singh",
    nameEn: "Leo",
    nameHi: "सिंह",
    number: 5,
    currentStatus: "none",
    currentPhaseLabel: "Not Active",
    approximatePeriod: "~2037 - 2044",
    nextSadeSati: "Begins when Saturn enters Cancer",
  },
  {
    id: "kanya",
    nameEn: "Virgo",
    nameHi: "कन्या",
    number: 6,
    currentStatus: "none",
    currentPhaseLabel: "Not Active",
    approximatePeriod: "~2039 - 2047",
    nextSadeSati: "Begins when Saturn enters Leo",
  },
  {
    id: "tula",
    nameEn: "Libra",
    nameHi: "तुला",
    number: 7,
    currentStatus: "none",
    currentPhaseLabel: "Not Active",
    approximatePeriod: "~2041 - 2049",
    nextSadeSati: "Begins when Saturn enters Virgo",
  },
  {
    id: "vrishchik",
    nameEn: "Scorpio",
    nameHi: "वृश्चिक",
    number: 8,
    currentStatus: "none",
    currentPhaseLabel: "Not Active",
    approximatePeriod: "~2044 - 2051",
    nextSadeSati: "Begins when Saturn enters Libra",
  },
  {
    id: "dhanu",
    nameEn: "Sagittarius",
    nameHi: "धनु",
    number: 9,
    currentStatus: "none",
    currentPhaseLabel: "Recently Ended",
    approximatePeriod: "2017 - 2025 (ended)",
    nextSadeSati: "~2047",
  },
  {
    id: "makar",
    nameEn: "Capricorn",
    nameHi: "मकर",
    number: 10,
    currentStatus: "rising",
    currentPhaseLabel: "Rising Phase (12th house)",
    approximatePeriod: "2020 - 2028",
    nextSadeSati: "Current cycle ongoing",
  },
  {
    id: "kumbh",
    nameEn: "Aquarius",
    nameHi: "कुंभ",
    number: 11,
    currentStatus: "peak",
    currentPhaseLabel: "Peak Phase (1st house)",
    approximatePeriod: "2023 - 2030",
    nextSadeSati: "Current cycle — peak phase",
  },
  {
    id: "meen",
    nameEn: "Pisces",
    nameHi: "मीन",
    number: 12,
    currentStatus: "setting",
    currentPhaseLabel: "Setting Phase (2nd house)",
    approximatePeriod: "2025 - 2032",
    nextSadeSati: "Current cycle — setting phase beginning",
  },
];

export const STATUS_STYLES: Record<
  string,
  { bg: string; border: string; text: string; badge: string; badgeBg: string }
> = {
  rising: {
    bg: "rgba(234, 179, 8, 0.06)",
    border: "rgba(234, 179, 8, 0.3)",
    text: "var(--color-warning-text-dark)",
    badge: "var(--color-warning-text)",
    badgeBg: "rgba(234, 179, 8, 0.15)",
  },
  peak: {
    bg: "rgba(220, 38, 38, 0.06)",
    border: "rgba(220, 38, 38, 0.3)",
    text: "var(--color-error-text)",
    badge: "var(--color-error-text-dark)",
    badgeBg: "rgba(220, 38, 38, 0.12)",
  },
  setting: {
    bg: "rgba(249, 115, 22, 0.06)",
    border: "rgba(249, 115, 22, 0.3)",
    text: "var(--color-warning-orange-dark)",
    badge: "#9a3412",
    badgeBg: "rgba(249, 115, 22, 0.12)",
  },
  none: {
    bg: "rgba(0, 0, 0, 0.02)",
    border: "var(--ish-border-light)",
    text: "var(--ish-text-muted)",
    badge: "var(--ish-text-faint)",
    badgeBg: "rgba(0, 0, 0, 0.04)",
  },
};
